import { render, staticRenderFns } from "./WorkTaskVda63Summary.vue?vue&type=template&id=3dcd29e6"
import script from "./WorkTaskVda63Summary.vue?vue&type=script&lang=ts"
export * from "./WorkTaskVda63Summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports